import { GET_COMPANY } from "@apiUtils";
import { mutationFetch } from "@atlas/sdk";
import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { USER_TENANTS_KEY } from "./HubUserTenants";

export interface ITermsAcceptanceRequest {
  termsId: string;
  signature: string;
}

export const acceptApplicationTerms = async (
  companyUuid: string,
  applicationId: string,
  request: ITermsAcceptanceRequest,
  basePath?: string,
): Promise<void> => {
  const path = `${GET_COMPANY}/${companyUuid}/applications/${applicationId}/terms-acceptance`;
  const url = basePath ? `${basePath.replace(/\/$/, "")}${path}` : path;
  return mutationFetch<void>({
    url,
    method: "POST",
    body: request,
  });
};

export const useAcceptApplicationTerms = (
  companyUuid: string | undefined,
  applicationId: string | undefined,
  basePath?: string,
  options?: Partial<
    UseMutationOptions<void, AxiosError, ITermsAcceptanceRequest, unknown>
  >,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ITermsAcceptanceRequest) =>
      acceptApplicationTerms(
        companyUuid ?? "",
        applicationId ?? "",
        request,
        basePath,
      ),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: [USER_TENANTS_KEY] });
      options?.onSuccess?.(...args);
    },
    ...options,
  });
};
